import gql from 'graphql-tag';

export const RUN_HISTORY_QUERY = gql`
  query RunHistoryQuery(
    $entityName: String!
    $projectName: String!
    $runName: String!
    $sampledHistorySpecs: [JSONString!]!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      run(name: $runName) {
        id
        sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
      }
    }
  }
`;
